function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CollapseIcon from './CollapseIcon';
import CheckboxItem from './ItemType/CheckboxItem';
import NodeItem from './ItemType/NodeItem';
import { ENTER_KEY, SPACE_KEYCODE, ARROW_LEFT_KEY, ARROW_RIGHT_KEY } from '../../Utils/constant';
import { TreeViewContext } from '../context/TreeViewProvider';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
function TreeViewItem(props) {
  var _treeNode$children, _treeNode$children2, _treeNode$children3, _treeNode$children4;
  const {
    treeNode = {},
    level = 0,
    onChange = () => {},
    onExpand = () => {},
    onSelect = () => {},
    // custom function to be executed when node item is selected.
    checkable = false,
    selectable = true,
    multiSelect = false,
    collapsible = true,
    expandAll = false,
    parentDisabled = false
  } = props;
  const {
    id: itemId = ''
  } = treeNode;
  const {
    expanded,
    setExpanded,
    selected,
    setSelected,
    checked: checkedList
  } = useContext(TreeViewContext);
  const indentation = collapsible && !(treeNode !== null && treeNode !== void 0 && (_treeNode$children = treeNode.children) !== null && _treeNode$children !== void 0 && _treeNode$children.length) ? 24 * (level + 1) : level * 24;
  // 24 * (level + 1)  => (level * 24) + 24 px  => (level * 24) + additional 16px chevron width + 8 px gap

  const showChildren = (expandAll || expanded.includes(itemId)) && !!(treeNode !== null && treeNode !== void 0 && (_treeNode$children2 = treeNode.children) !== null && _treeNode$children2 !== void 0 && _treeNode$children2.length);
  const isTreeNodeDisabled = !!(treeNode !== null && treeNode !== void 0 && treeNode.disabled) || parentDisabled;
  const isCheckboxSelected = checkedList.has(itemId);
  const isNodeItemSelected = selectable && selected.includes(itemId);
  const treeItemContentClasses = classNames({
    [treeStyles['sib-tree-view__item-content']]: true,
    [treeStyles['sib-tree-view__item-content--selected']]: isNodeItemSelected,
    [treeStyles['sib-tree-view__item-content--nodeItem']]: !checkable
  });
  const onSelectHandler = e => {
    let newSelectedIds = [...selected];
    const index = selected.indexOf(itemId);
    if (index >= 0) {
      // if item clicked on is already present in the selected list
      multiSelect ? newSelectedIds.splice(index, 1) : newSelectedIds = [];
    } else {
      multiSelect ? newSelectedIds.push(itemId) : newSelectedIds = [itemId];
    }
    setSelected(newSelectedIds);
    onSelect(e, newSelectedIds);
  };
  const onChevronClickHandler = e => {
    let newExpanded = [...expanded] || [];
    if (e.key === ARROW_LEFT_KEY) {
      if (newExpanded.includes(itemId)) {
        newExpanded = newExpanded.filter(expandedId => expandedId != itemId);
      } else {
        return;
      }
    } else if (e.key === ARROW_RIGHT_KEY) {
      if (!newExpanded.includes(itemId)) {
        newExpanded.push(itemId);
      } else {
        return;
      }
    } else {
      newExpanded = newExpanded.includes(itemId) ? newExpanded.filter(expandedId => expandedId != itemId) : [...newExpanded, itemId];
    }
    setExpanded(newExpanded);
    onExpand(e, newExpanded);
  };
  const handleKeyPress = e => {
    var _e$target;
    e.stopPropagation();
    const keysToIgnore = [ARROW_LEFT_KEY, ARROW_RIGHT_KEY];
    // prevent focus from shifting when LEFT/ RIGHT arrow keys are hit
    if (keysToIgnore.includes(e.key)) {
      e.preventDefault();
    }

    // hitting SPACE/ ENTER key should select/ de-select the tree item if it is of node item item.
    // if its a checkbox item, no action takes place.
    if (!checkable && selectable && !isTreeNodeDisabled && (e.key === ENTER_KEY || e.keyCode === SPACE_KEYCODE)) {
      onSelectHandler(e);
    }
    // hitting LEFT/ RIGHT ARROW keys should expand/ collapse nested lists
    if (collapsible && !isTreeNodeDisabled && (e.key === ARROW_LEFT_KEY || e.key === ARROW_RIGHT_KEY) && ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.id) == `treeItem-${itemId}`) {
      onChevronClickHandler(e);
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    className: treeStyles['sib-tree-view__item'],
    role: "treeitem",
    disabled: isTreeNodeDisabled,
    style: isTreeNodeDisabled ? {
      pointerEvents: 'none',
      cursor: 'not-allowed'
    } : {},
    tabIndex: isTreeNodeDisabled ? -1 : 0,
    "aria-selected": isCheckboxSelected || isNodeItemSelected,
    onKeyDown: e => {
      handleKeyPress(e);
    },
    id: `treeItem-${itemId}`
  }, /*#__PURE__*/React.createElement("div", {
    className: treeItemContentClasses,
    style: {
      marginLeft: `${indentation}px`
    },
    disabled: isTreeNodeDisabled
  }, collapsible && treeNode !== null && treeNode !== void 0 && (_treeNode$children3 = treeNode.children) !== null && _treeNode$children3 !== void 0 && _treeNode$children3.length ? /*#__PURE__*/React.createElement(CollapseIcon, {
    itemId: itemId,
    isNodeItem: !!(treeNode !== null && treeNode !== void 0 && treeNode.nodeItem),
    onChevronClickHandler: onChevronClickHandler
  }) : null, checkable ? /*#__PURE__*/React.createElement(CheckboxItem, {
    treeNode: treeNode,
    onChange: onChange,
    isTreeNodeDisabled: isTreeNodeDisabled
  }) : /*#__PURE__*/React.createElement(NodeItem, {
    treeNode: treeNode,
    selectable: selectable,
    onSelectHandler: onSelectHandler
  })), showChildren ? /*#__PURE__*/React.createElement("ul", {
    className: treeStyles['sib-tree-view__sublist'],
    role: "group"
  }, treeNode === null || treeNode === void 0 ? void 0 : (_treeNode$children4 = treeNode.children) === null || _treeNode$children4 === void 0 ? void 0 : _treeNode$children4.map((childNode, i) => /*#__PURE__*/React.createElement(TreeViewItem, _extends({}, props, {
    key: i,
    treeNode: childNode,
    level: level + 1,
    parentDisabled: isTreeNodeDisabled
  })))) : null);
}
TreeViewItem.propTypes = {
  treeNode: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.string,
    helpButtonMetaData: PropTypes.object,
    disabled: PropTypes.bool,
    nodeItem: PropTypes.func,
    children: PropTypes.array
  }),
  level: PropTypes.number,
  onChange: PropTypes.func,
  onExpand: PropTypes.func,
  onSelect: PropTypes.func,
  collapsible: PropTypes.bool,
  checkable: PropTypes.bool,
  selectable: PropTypes.bool,
  multiSelect: PropTypes.bool,
  expandAll: PropTypes.bool,
  parentDisabled: PropTypes.bool
};
export default TreeViewItem;